import { Dropdown } from "react-bootstrap";
import { useSystem } from "../../hooks/use-system";
import { Globe } from "react-feather";

function LanguageSelector({ supportedLanguages }) {
  const system = useSystem();
  const handleLangSelect = (lang) => {
    localStorage.setItem("nj_lang", lang);
    system.setLanguage(lang);
  };
  return Object.keys(supportedLanguages).length > 1 ? (
    <div className="language-selector flex justify-center items-center h-full">
      <Dropdown>
        <Dropdown.Toggle
          variant="outline outline-primary btn-sm"
          id="dropdown-basic"
          style={{
            border: "1px solid #e3e3e3",
            borderRadius: "5px",
          }}
        >
          {system.language.toUpperCase()}
        </Dropdown.Toggle>

        <Dropdown.Menu
          style={{
            border: "1px solid #e3e3e3",
            borderRadius: "5px",
          }}
        >
          {Object.keys(supportedLanguages).map((lang) => {
            return (
              <Dropdown.Item
                onClick={() => handleLangSelect(lang)}
                key={`lang_${lang}`}
              >
                {lang.toUpperCase()}
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  ) : null;
}

export default LanguageSelector;
